// Informational signals strip; each chip expands to the actual items.
import { T } from "../../../app/tokens.js";
import { tx } from "./travelStyles.js";
import { fmtCivil, holidayLabel } from "./travelModel.js";

export function TravelSignals({ signals, showNames, onOpenTrip, onOpenProject, open }) {
  const gaps = signals?.milestoneGaps || [];
  const doubles = signals?.doubleBookings || [];
  const hols = signals?.holidayOverlaps || [];
  if (!["gaps", "doubles", "hols"].includes(open)) return null;
  const count = open === "gaps" ? gaps.length : open === "doubles" ? doubles.length : hols.length;
  return (
    <div data-testid="travel-signal-evidence" style={{ marginBottom: 12 }}>
      {!count && <div role="status" style={{ fontSize: T.fsSm, color: T.mid }}>No matching signal evidence.</div>}
      {open && (
        <ul data-testid={`travel-signal-list-${open}`} style={{ ...tx.card, listStyle: "none", margin: "8px 0 0", padding: "6px 0", fontSize: T.fsSm }}>
          {open === "gaps" && gaps.map((g) => (
            <li key={g.milestoneId} style={{ padding: "6px 14px", display: "flex", gap: 8, flexWrap: "wrap" }}>
              <span style={{ color: T.travelAmberFg, fontWeight: T.fwBold }}>Due {fmtCivil(g.dueDate)}</span>
              <button type="button" style={tx.link} onClick={() => onOpenProject(g.projectId,"timeline")}>{g.milestoneName}</button>
              <button type="button" data-testid={`travel-gap-project-${g.milestoneId}`} style={tx.link} onClick={() => onOpenProject(g.projectId)}>{g.projectName}</button>
            </li>
          ))}
          {open === "doubles" && doubles.map((d, i) => (
            <li key={`${d.personId}-${d.tripIds.join("-")}`} style={{ padding: "6px 14px", display: "flex", gap: 8, flexWrap: "wrap" }}>
              <b>{showNames ? d.displayName : `Traveler ${i + 1}`}</b>
              {d.tripIds.map((id, j) => (
                <button key={id} type="button" data-testid={`travel-double-trip-${id}`} style={tx.link} onClick={() => onOpenTrip(id)}>{d.tripTitles[j] || "Trip"}</button>
              ))}
            </li>
          ))}
          {open === "hols" && hols.map((h) => (
            <li key={h.tripId} style={{ padding: "6px 14px", display: "flex", gap: 8, flexWrap: "wrap" }}>
              <button type="button" data-testid={`travel-holiday-trip-${h.tripId}`} style={tx.link} onClick={() => onOpenTrip(h.tripId)}>{h.title}</button>
              <span style={{ color: T.mid }}>{(h.holidays || []).map((x) => `${holidayLabel(x)} ${fmtCivil(x.date)}${x.name ? ` (${x.name})` : ""}`).join("; ")}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
